// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".widget-search>:not(.widget-search-results):not(:last-child){min-height:-moz-fit-content;min-height:fit-content;padding-bottom:.25rem}.widget-search>aside{z-index:39}.widget-search-results{border-top:1px solid #d3d3d3}.widget-search>.pagination{margin-top:1rem!important;margin-bottom:1rem!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
